import { Button, H5, Icon, InputGroup, Tooltip } from '@blueprintjs/core';
import ResourceData from 'Data/ResourceData';

import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from './Resources.module.css';

const InventoryTagLabelAndLink = ({ inventory_tag_number }) => {
  return (
    inventory_tag_number && (
      <div
        style={{
          display: 'flex',
          alignItems: 'middle',
        }}>
        {inventory_tag_number}
        <Tooltip minimal content={'Launch asset in the Inventory System'}>
          <button
            className={styles.resource_lookup_button}
            onClick={() =>
              ResourceData.linkAssetInventoryPage(inventory_tag_number)
            }>
            <Icon icon={'open-application'} />
          </button>
        </Tooltip>
      </div>
    )
  );
};

InventoryTagLabelAndLink.propTypes = {
  inventory_tag_number: PropTypes.string,
};

const InventorySearchButton = ({ closeButton }) => {
  const [inventoryTagNumber, setInventoryTagNumber] = useState();
  return (
    <div className={styles.resource_lookup_box}>
      {closeButton && (
        <div className={styles.resource_lookup_close_box}>{closeButton}</div>
      )}
      <H5>Inventory System Lookup</H5>
      <div>Adding a resource that is in the Inventory System?</div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingTop: 20,
        }}>
        <InputGroup
          value={inventoryTagNumber || ''}
          placeholder={'Inventory Tag Number'}
          onValueChange={(value) => {
            setInventoryTagNumber(value);
          }}
        />
        <Tooltip
          minimal
          content={
            !inventoryTagNumber
              ? 'Enter the tag number for the resource.'
              : 'Search Inventory System for asset details'
          }>
          <Button
            disabled={!inventoryTagNumber}
            className={styles.resource_lookup_button}
            icon={'search'}
            onClick={() => {
              ResourceData.getAssetInformation(inventoryTagNumber);
              setInventoryTagNumber(undefined);
            }}>
            Retrieve Details
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

InventorySearchButton.propTypes = {
  closeButton: PropTypes.element,
};

export { InventoryTagLabelAndLink, InventorySearchButton };
